import React from "react";
import { NavLink } from "react-router-dom";
import Testimonials from "../../components/home/Testimonials";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Cta from "../../components/cta/cta";
import ListBuildingBanner from "../../assets/images/list-building/list-building-banner.png";
import CustomSegmentation from "../../assets/images/list-building/custom-segmentation.png";
import DataEnrichment from "../../assets/images/list-building/data-enrichment.png";
import SmartFilters from "../../assets/images/list-building/smartFilters.png";
import EasyIntegrations from "../../assets/images/list-building/easyIntegrations.png";

const ListBuildingPage = () => {
  return (
    <>
      <div className="sales-wrapper">
        <section className="sales-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center">
                <div>
                  <p
                    className="heading16px roboto-regular mb10"
                    style={{ fontWeight: "bold" }}
                  >
                    BEYONDLEADZ: DATA TO LEAD
                  </p>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    Targeting and <br /> Engage Instantly
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    In today’s competitive landscape, reaching the right
                    audience is paramount. With BeyondLeadz's cutting-edge Data-to-Lead feature, you can curate targeted lists that match
                    your ideal customer profile with unmatched precision.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Subscribe Now
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/contact-us"}
                        className="common-btn-class transparentBtn roboto-regular"
                      >
                        Contact us
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={ListBuildingBanner}
                    className="img-responsive position-relative"
                    alt="Double Your Qualified Leads"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section>
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Your Target, Our Precision
              </h2>

              <div className="grid-auto-fit mb60 max-width950">
                <div>
                  <img
                    src={CustomSegmentation}
                    className="img-responsive position-relative mb30"
                    alt="Custom Segmentation"
                  />
                  <h3 className="roboto-bold heading20px mb10">
                    Custom Segmentation
                  </h3>
                  <p className="roboto-regular heading16px">
                    Tailor your lists based on specific demographics, behaviors,
                    and interests to maximize the effectiveness of your
                    campaigns.
                  </p>
                </div>
                <div>
                  <img
                    src={DataEnrichment}
                    className="img-responsive position-relative mb30"
                    alt="Data Enrichment"
                  />
                  <h3 className="roboto-bold heading20px mb10">
                    Data Enrichment
                  </h3>
                  <p className="roboto-regular heading16px">
                    Integrate with third-party data sources to enhance the
                    quality of your lists, ensuring you have the most accurate
                    and up-to-date information.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit max-width950">
                <div>
                  <img
                    src={SmartFilters}
                    className="img-responsive position-relative mb30"
                    alt="Smart Filters"
                  />
                  <h3 className="roboto-bold heading20px mb10">
                    Smart Filters
                  </h3>
                  <p className="roboto-regular heading16px">
                    Use advanced filtering options to narrow down your prospects
                    and focus on leads with the highest conversion potential.
                  </p>
                </div>
                <div>
                  <img
                    src={EasyIntegrations}
                    className="img-responsive position-relative mb30"
                    alt="Easy Integration"
                  />
                  <h3 className="roboto-bold heading20px mb10">
                    Easy Integration
                  </h3>
                  <p className="roboto-regular heading16px">
                    Seamlessly integrate your lists with your CRM and marketing
                    automation tools, streamlining your workflow and ensuring
                    consistency across platforms.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default ListBuildingPage;
